
















import { defineComponent } from "@vue/composition-api";
import { VueConstructor } from "vue";
import { ContentPriceSubjectTypeEnum } from "@scrile/api-provider/dist/api/ContentPriceProvider";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { PurchaseSubjectTypeEnum } from "@scrile/api-provider/dist/api/PurchaseTypeProvider";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { formatMoneyString, getMainCurrencyCode } from "@/lib/moneyHelpers";
import PaymentManager from "@/payments";
import { PurchaseResponse } from "@/payments/types";
import { BlockingStatus } from "@/types";
import { EVENTS } from "@/const";
import { getMessageView } from "./views";

export default defineComponent({
  name: "MessageItem",
  props: {
    message: { type: Object as () => Message, required: true },
    authUserId: { type: String, required: true },
    userId: { type: String, required: true },
    canManageMessages: { type: Boolean, required: true },
    paymentPackages: { type: Array as () => PaymentPackage[], required: true },
    blockingStatus: { type: Object as () => BlockingStatus, required: true },
    blurMedia: { type: Boolean, default: false },
  },
  computed: {
    viewComponent(): VueConstructor {
      return getMessageView(this.message);
    },
  },
  methods: {
    async purchase(onRequestEnd: Function) {
      try {
        if (!this.message.attachmentPricePackageId) {
          return;
        }
        const cost = this.paymentPackages
          .find(p => p.id === this.message.attachmentPricePackageId)
          ?.costs?.find(c => c.currency === getMainCurrencyCode())?.cost;
        const price = (cost && formatMoneyString(cost, { currencyCode: getMainCurrencyCode() })) || undefined;
        const response: PurchaseResponse = await PaymentManager.purchase({
          pricePackageId: this.message.attachmentPricePackageId,
          price,
          subject: {
            subjectId: this.message.id,
            subjectType: PurchaseSubjectTypeEnum.MESSAGE_ATTACHMENT,
          },
        });
        if (response.status && !response.subjectPurchased) {
          await providers.ContentPriceProvider.purchase({
            data: {
              subjectId: this.message.id,
              subjectType: ContentPriceSubjectTypeEnum.MESSAGE_ATTACHMENT,
            },
          });
        }
        if (response.status) {
          emitter.emit(EVENTS.MESSAGES_UPDATE_MESSAGE, this.message.id);
        }
        onRequestEnd(true);
      } catch (e) {
        onRequestEnd(false);
      }
    },
  },
});
